module.exports = __webpack_public_path__ + "img/eps.1647a066.png";